import {ref, Ref} from "vue"
import DisabledServices from "@/logic/errorHandling/DisabledServices"
import getDisabledServices from "@/logic/errorHandling/func/getDisabledServices"

const disabledServices: Ref<DisabledServices | null> = ref(getDisabledServices() || null)

export default disabledServices